import { Component, OnInit } from '@angular/core';
import { UsuariosService } from 'app/_services/usuarios.service';
import { SeguridadService } from 'app/_services/seguridad.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalEventsManager } from 'app/_services/globaleventsmanager.service';
import { ConfirmationService } from 'primeng/primeng';
import { TiendaService } from 'app/_services/tienda.service';

@Component({
  selector: 'usuarioroles',
  templateUrl: './usuarioroles.component.html',
  styleUrls: ['./usuarioroles.component.css']
})
export class UsuariorolesComponent implements OnInit {

  subscription: Subscription;
  listaRoles: any = [];
  id_role: number = 0;
  roleSeleccionado: number = 0;

  mostrarFormularioRoles: boolean = false;
  mostrarUsuariosRolesApps: boolean = false;
  iconoexpandir: string;
  expandir: any;


  constructor(private usuariosService: UsuariosService,
              private seguridad: SeguridadService,
              private router: Router,
              private globalEventsManager: GlobalEventsManager,
              private confirmationService: ConfirmationService,
              private tiendaService: TiendaService) { }

  ngOnInit() {

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
      if (mode !== null) {
        if (!mode) {
          this.router.navigate(['login']);
        }
      }
    });

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path': '/usuarios roles',
        'name': 'Administración de roles'
      },
      {
        'path': '#',
        'name': 'Usuarios'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    this.getListaRoles();

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getListaRoles() {
    this.usuariosService.getListaRoles().subscribe(
      data => {
        if (data) {
          this.listaRoles = data.json().lista;
          console.log(this.listaRoles);
        }
      }
    );

  }

  nuevoRole() {

    this.id_role = 0;
    this.mostrarFormularioRoles = true;
  }

  editarRole(id_role: number) {

    this.id_role = id_role;
    this.roleSeleccionado = id_role;
    this.mostrarUsuariosRolesApps = false;
    this.mostrarFormularioRoles = true;
  }

  onCloseRole(event) {
    if (event == 0) {
      this.roleSeleccionado = 0;
      this.mostrarFormularioRoles = false;
    }
  }

  onChangeRole(event) {
    if (event == true) {
      this.mostrarFormularioRoles = false;
      this.getListaRoles();
    }
  }

  AsignarAppsRole(id_role) {
    this.id_role = id_role;
    this.mostrarUsuariosRolesApps = true;
    this.mostrarFormularioRoles = false;
  }

  onCloseRoleApps(event) {
    this.roleSeleccionado = 0;
    this.mostrarUsuariosRolesApps = false;
  }

  confirmDeleteRole(id_role: number) {
  
    this.confirmationService.confirm({
      message: '¿Seguro que deseas eliminar el role?',
      accept: () => {
            this.deleteRole(id_role);
      }
    });
  }

  deleteRole(id_role) {
    this.tiendaService.deleteRoleMaestra(id_role).subscribe(
      data => {
        if (data) {
          let al: any = {
            "texto": "Role eliminado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);
          this.getListaRoles();

        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarioroles/usuarioroles.component.ts